import {Box} from "@cjdev-internal/visual-stack-x/Box";

const ActionButtons = ({CreateRecordModal, BulkUploadAndDownloadDropDown}) => {
    return (
        <Box direction="row">
            <Box paddingRight={"medium"}>
            <CreateRecordModal/>
            </Box>
            <BulkUploadAndDownloadDropDown/>
        </Box>
    )
}


export default ActionButtons;